// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/lanluma/3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/maili/1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/dimono/mobile-img-hero-bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media(min-width:1399px){
    .image-hero-parent span{
       width: 90%;
    }
}

.dimono-image-hero-1::before,
.lanluma-image-hero-1::before {
    background-size: contain !important;
}

@media(min-width: 992px) {
    .lensina-image-hero-2 p{
        width: 80%;
    }
    .image-hero-parent span,
    .image-hero-parent p {
        text-align: justify !important;
        font-size: 18px !important;
    }

    .image-hero-parent .container{
        padding-left: 176px;
        padding-right: 176px;
    }

    html[dir='rtl'] .image-hero-parent::before {
        background-position: left bottom;
    }

    .image-hero-parent h3,
    .image-hero-parent h2 {
        font-size: 36px !important;
        font-weight: 400 !important;

    }

    .image-hero-parent span {
        margin-top: 32px !important;
        font-size: 18px !important;
    }

    .maili-image-hero-1 h3 {
        font-size: 36px !important;
    }

    .maili-image-hero-1 span,
    .drcyj-image-hero-1 span {
        margin-top: 32px !important;
        font-size: 18px !important;
    }

    .drcyj-image-hero-1 {
        min-height: unset !important;
        /* height: 65vh; */
    }
    .drcyj-image-hero-1::before{
        background-position: -222px 8px!important;
}
    .dimono-image-hero-1 {
        background-position: -36px 88px;
    }
}

@media(min-width: 768px) and (max-width: 991px) {

    .image-hero-parent h3,
    .image-hero-parent h2 {
        font-size: 32px !important;
    }

    .ellanse-logo {
        width: 211px;
        height: 59px;
        margin-right: auto !important;
        margin-bottom: 0 !important;

    }

    .image-hero-parent .container{
        padding-left: 96px !important;
        padding-right: 96px !important;

    }

    html[dir='ltr'] .image-hero-parent.leninsa-hero-1,
    html[dir='ltr'] .image-hero-parent.lensina-image-hero-2 {

        padding-left: 64px !important;

    }

    html[dir='rtl'] .image-hero-parent.leninsa-hero-1,
    html[dir='rtl'] .image-hero-parent.lensina-image-hero-2 {
        padding-right: 64px !important;
    }

    .image-hero-parent.ksurgery-image-hero {
        padding-left: 32px !important;
    }

    html[dir='rtl'] .image-hero-parent.ksurgery-image-hero {
        padding-right: 64px !important;
        padding-left: 0 !important;
    }

    .image-hero-parent.dimono-image-hero-1 {
        padding-left: 64px;
        padding-right: 64px !important;
    }

    html[dir='rtl'] .ksurgery-stack {
        /* align-items: flex-start!important; */
    }

    .text-holder {
        padding-left: 0 !important;
        text-align: start !important;
    }

    html[dir='rtl'] .text-holder {
        padding-right: 0 !important;
    }

    .text-holder p,
    .text-holder span {
        width: 60%;
        text-align: justify !important;
        margin-right: auto !important;
        font-size: 15px !important;
    }

    html[dir='rtl'] .text-holder p,
    html[dir='rtl'] .text-holder span {
        /* width: 60%; */
        margin-left: auto !important;
        margin-right: 0 !important;
    }




    .drcyj-image-hero-1:before {
        background-position: -260px 50px !important;
    }

    .lensina-image-hero-2 p {
        margin-top: 32px !important;
    }

    .lanluma-image-hero-1::before {
        right: -232px !important;
    }

    .lanluma-image-hero-1 h3 {
        font-size: 32px !important;
    }

    .lanluma-image-hero-1 span {
        font-size: 18px !important;
        width: 70% !important;
    }

    .maili-image-hero-1 h3 {
        font-size: 2rem;
        margin-bottom: 8px !important;
    }

    .ellanse-hero-image-1 h3 {
        font-size: 29px !important;
        font-weight: 400 !important;
    }

    .ellanse-hero-image-1:before {
        background-position: -100px !important;

    }

    .ellanse-hero-image-1 span {
        margin-top: 27px !important;
    }

    .dimono-image-hero-1 {
        background-position: -25px 100px;
        background-repeat: no-repeat;
    }

    .dimono-image-hero-1::before {
        background-size: 50% !important;
        /* background-position: 0 110px !important; */
    }

    .dimono-image-hero-1 {
        padding-left: 64px !important;
        background-position: -56px 150px;
        background-repeat: no-repeat;
    }

    html[dir='rtl'] .dimono-image-hero-1 {
        background-position: right;
    }

    html[dir='rtl'] .dimono-image-hero-1::before {
        /* transform: none!important; */
        left: -50%;
    }

    .dimono-image-hero-1 h3 {
        font-size: 2rem;
        font-weight: 400;
    }


    html[dir='rtl'] .drcyj-image-hero-1 {

        padding-right: 60px !important;
    }

    html[dir='ltr'] .drcyj-image-hero-1 {

        padding-left: 60px !important;
    }

    .drcyj-story-section-1 span {
        word-spacing: 0;
    }

    .maili-image-hero-1 ,.ellanse-hero-image-1{
        padding-left: 64px !important;
    }

    html[dir='rtl'] .maili-image-hero-1 ,   html[dir='rtl'] .lanluma-image-hero-1,  html[dir='rtl'] .ellanse-hero-image-1 {
        padding-right: 64px !important;
    }

    html[dir='ltr'] .lanluma-image-hero-1, html[dir='ltr'] .ellanse-hero-image-1 {
        padding-left: 64px !important;
    }
    html[dir='rtl'] .lanluma-image-hero-1::before {

        left: -345px;
        right: unset !important;
    }

    html[dir='rtl'] .lanluma-image-hero-1 span {
        font-size: 18px !important;
        width: 60% !important;
    }
    html[dir='rtl'] .ellanse-logo{
        margin-left: auto!important;
        margin-right: 0!important;
    }
    /* html[dir='rtl'] .ell */
}



@media(max-width: 767px) {
    .ksurgery-image-hero {
        height: 400px;
    }

    .ksurgery-image-hero:before {
        background-position: right !important;
        background-color: red
    }

    .ksurgery-image-hero h3 {
        font-size: 20px !important;
    }

    .ksurgery-image-hero h4 {
        font-size: 14px !important;
        font-weight: 600;
    }

    .ksurgery-image-hero p,
    .juvelook-hero-1 p {
        text-align: left !important;
    }
   html[dir='rtl'] .ksurgery-image-hero p,
   html[dir='rtl']  .juvelook-hero-1 p {
        text-align: right !important;
    }

    .ksurgery-image-hero ul {
        margin-top: 24px !important;
    }

    .ksurgery-image-hero ul li {
        font-size: 14px !important;
    }

    .juvelook-hero-1,
    .juvelook-hero-2,
    .leninsa-hero-1 {
        height: 100vh !important;
    }

    .leninsa-hero-1 .text-holder,
    .lensina-image-hero-2 .text-holder {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }

    .leninsa-hero-1 {
        background-color: rgba(0, 0, 0, 0.6);
    }

    .ellanse-hero-image-1:before {
        background-image: none !important;
    }

    .ellanse-hero-image-1 svg {
        margin-right: auto !important;
    }

    .ellanse-hero-image-1 {
        height: auto !important;
        padding: 16px 0 !important;
    }

    .lanluma-image-hero-1 {
        background-image: none !important;
        height: 100vh !important;

    }

    .lanluma-image-hero-1::before {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
        transform: none !important;
        filter: brightness(50%);
        background-position: 30% !important;
        background-size: cover !important;

    }

    .lanluma-image-hero-1 h3 {
        margin-top: 17vh !important;
        font-size: 2.25rem !important;
        font-weight: 400 !important;
    }

    .lanluma-image-hero-1 h3,
    .lanluma-image-hero-1 span {
        color: white;
    }

    .lanluma-image-hero-1 span {

        font-size: 1.125rem !important;
    }


    .maili-image-hero-1 {
        height: 70vh !important;
    }

    .text-holder {
        padding: 32px !important;
    }

    .maili-image-hero-1:before {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
        background-size: cover !important;
        filter: brightness(50%);
        background-position: center left !important;
        transform: none !important;

    }

    .maili-image-hero-1 h3 {
        /* margin-top: 40px!important; */
    }

    .dimono-image-hero-1 {
        height: 90vh !important;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;


        background-position: right bottom !important;
        background-size: 100px !important;
        background-repeat: no-repeat !important;
        z-index: 9;
        /* filter: grayscale(0.1); */
    }

    .dimono-image-hero-1:before {
        background-image: none !important;
        /* background-color: #E5E5E5; */

    }

    .juvelook-hero-2 h2,
    .dimono-image-hero-1 h3,
    .drcyj-image-hero-1 h3,
    .lanluma-image-hero-1 h3,
    .lensina-image-hero-2 h2,
    .lensina-image-hero-1 h2,
    .juvelook-hero-1 h2 {
        margin-bottom: 60px !important;
        margin-top: 17vh !important;
        font-size: 2.25rem;
        font-weight: 400 !important;

    }

    .juvelook-hero-2 p,
    .dimono-image-hero-1 span,
    .drcyj-image-hero-1 span,
    .lensina-image-hero-2 span,
    .juvelook-hero-1 p {
        font-size: 18px;

    }

    .drcyj-image-hero-1 {
        height: 100vh !important;
        /* background-color: red; */
        background-color: rgba(0, 0, 0, 0.9);
    }

    .drcyj-image-hero-1:before {
        background-position: 70% !important;
        background-size: cover !important;
        filter: brightness(50%);

    }

    .drcyj-image-hero-1 span,
    .drcyj-image-hero-1 h3 {
        color: white !important;
    }

    .drcyj-image-hero-1:after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
    }

    .lensina-image-hero-2 {
        height: 100vh !important;
    }

}`, "",{"version":3,"sources":["webpack://./src/layout/components/ImageHero.css"],"names":[],"mappings":"AAAA;IACI;OACG,UAAU;IACb;AACJ;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI;QACI,UAAU;IACd;IACA;;QAEI,8BAA8B;QAC9B,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;;QAEI,0BAA0B;QAC1B,2BAA2B;;IAE/B;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,2BAA2B;QAC3B,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;QAC5B,kBAAkB;IACtB;IACA;QACI,yCAAyC;AACjD;IACI;QACI,+BAA+B;IACnC;AACJ;;AAEA;;IAEI;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,6BAA6B;QAC7B,2BAA2B;;IAE/B;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;;IAElC;;IAEA;;;QAGI,6BAA6B;;IAEjC;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;QAC9B,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;QAClB,8BAA8B;IAClC;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;QAEI,UAAU;QACV,8BAA8B;QAC9B,6BAA6B;QAC7B,0BAA0B;IAC9B;;IAEA;;QAEI,gBAAgB;QAChB,4BAA4B;QAC5B,0BAA0B;IAC9B;;;;;IAKA;QACI,2CAA2C;IAC/C;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,sCAAsC;;IAE1C;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,gCAAgC;QAChC,4BAA4B;IAChC;;IAEA;QACI,+BAA+B;QAC/B,6CAA6C;IACjD;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;QAChC,4BAA4B;IAChC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,+BAA+B;QAC/B,UAAU;IACd;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;;IAGA;;QAEI,8BAA8B;IAClC;;IAEA;;QAEI,6BAA6B;IACjC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;IACjC;IACA;;QAEI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;QAC1B,qBAAqB;IACzB;IACA;QACI,2BAA2B;QAC3B,yBAAyB;IAC7B;IACA,yBAAyB;AAC7B;;;;AAIA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,qCAAqC;QACrC;IACJ;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;;QAEI,2BAA2B;IAC/B;GACD;;QAEK,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;;QAGI,wBAAwB;IAC5B;;IAEA;;QAEI,kBAAkB;QAClB,QAAQ;QACR,2BAA2B;IAC/B;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,uBAAuB;QACvB,0BAA0B;IAC9B;;IAEA;QACI,iCAAiC;QACjC,wBAAwB;;IAE5B;;IAEA;QACI,oEAAwD;QACxD,0BAA0B;QAC1B,uBAAuB;QACvB,mCAAmC;QACnC,iCAAiC;;IAErC;;IAEA;QACI,2BAA2B;QAC3B,6BAA6B;QAC7B,2BAA2B;IAC/B;;IAEA;;QAEI,YAAY;IAChB;;IAEA;;QAEI,8BAA8B;IAClC;;;IAGA;QACI,uBAAuB;IAC3B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,oEAAsD;QACtD,iCAAiC;QACjC,uBAAuB;QACvB,2CAA2C;QAC3C,0BAA0B;;IAE9B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,uBAAuB;QACvB,oEAAwE;;;QAGxE,4CAA4C;QAC5C,iCAAiC;QACjC,uCAAuC;QACvC,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,iCAAiC;QACjC,+BAA+B;;IAEnC;;IAEA;;;;;;;QAOI,8BAA8B;QAC9B,2BAA2B;QAC3B,kBAAkB;QAClB,2BAA2B;;IAE/B;;IAEA;;;;;QAKI,eAAe;;IAEnB;;IAEA;QACI,wBAAwB;QACxB,2BAA2B;QAC3B,oCAAoC;IACxC;;IAEA;QACI,mCAAmC;QACnC,iCAAiC;QACjC,uBAAuB;;IAE3B;;IAEA;;QAEI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,WAAW;QACX,YAAY;QACZ,oCAAoC;IACxC;;IAEA;QACI,wBAAwB;IAC5B;;AAEJ","sourcesContent":["@media(min-width:1399px){\n    .image-hero-parent span{\n       width: 90%;\n    }\n}\n\n.dimono-image-hero-1::before,\n.lanluma-image-hero-1::before {\n    background-size: contain !important;\n}\n\n@media(min-width: 992px) {\n    .lensina-image-hero-2 p{\n        width: 80%;\n    }\n    .image-hero-parent span,\n    .image-hero-parent p {\n        text-align: justify !important;\n        font-size: 18px !important;\n    }\n\n    .image-hero-parent .container{\n        padding-left: 176px;\n        padding-right: 176px;\n    }\n\n    html[dir='rtl'] .image-hero-parent::before {\n        background-position: left bottom;\n    }\n\n    .image-hero-parent h3,\n    .image-hero-parent h2 {\n        font-size: 36px !important;\n        font-weight: 400 !important;\n\n    }\n\n    .image-hero-parent span {\n        margin-top: 32px !important;\n        font-size: 18px !important;\n    }\n\n    .maili-image-hero-1 h3 {\n        font-size: 36px !important;\n    }\n\n    .maili-image-hero-1 span,\n    .drcyj-image-hero-1 span {\n        margin-top: 32px !important;\n        font-size: 18px !important;\n    }\n\n    .drcyj-image-hero-1 {\n        min-height: unset !important;\n        /* height: 65vh; */\n    }\n    .drcyj-image-hero-1::before{\n        background-position: -222px 8px!important;\n}\n    .dimono-image-hero-1 {\n        background-position: -36px 88px;\n    }\n}\n\n@media(min-width: 768px) and (max-width: 991px) {\n\n    .image-hero-parent h3,\n    .image-hero-parent h2 {\n        font-size: 32px !important;\n    }\n\n    .ellanse-logo {\n        width: 211px;\n        height: 59px;\n        margin-right: auto !important;\n        margin-bottom: 0 !important;\n\n    }\n\n    .image-hero-parent .container{\n        padding-left: 96px !important;\n        padding-right: 96px !important;\n\n    }\n\n    html[dir='ltr'] .image-hero-parent.leninsa-hero-1,\n    html[dir='ltr'] .image-hero-parent.lensina-image-hero-2 {\n\n        padding-left: 64px !important;\n\n    }\n\n    html[dir='rtl'] .image-hero-parent.leninsa-hero-1,\n    html[dir='rtl'] .image-hero-parent.lensina-image-hero-2 {\n        padding-right: 64px !important;\n    }\n\n    .image-hero-parent.ksurgery-image-hero {\n        padding-left: 32px !important;\n    }\n\n    html[dir='rtl'] .image-hero-parent.ksurgery-image-hero {\n        padding-right: 64px !important;\n        padding-left: 0 !important;\n    }\n\n    .image-hero-parent.dimono-image-hero-1 {\n        padding-left: 64px;\n        padding-right: 64px !important;\n    }\n\n    html[dir='rtl'] .ksurgery-stack {\n        /* align-items: flex-start!important; */\n    }\n\n    .text-holder {\n        padding-left: 0 !important;\n        text-align: start !important;\n    }\n\n    html[dir='rtl'] .text-holder {\n        padding-right: 0 !important;\n    }\n\n    .text-holder p,\n    .text-holder span {\n        width: 60%;\n        text-align: justify !important;\n        margin-right: auto !important;\n        font-size: 15px !important;\n    }\n\n    html[dir='rtl'] .text-holder p,\n    html[dir='rtl'] .text-holder span {\n        /* width: 60%; */\n        margin-left: auto !important;\n        margin-right: 0 !important;\n    }\n\n\n\n\n    .drcyj-image-hero-1:before {\n        background-position: -260px 50px !important;\n    }\n\n    .lensina-image-hero-2 p {\n        margin-top: 32px !important;\n    }\n\n    .lanluma-image-hero-1::before {\n        right: -232px !important;\n    }\n\n    .lanluma-image-hero-1 h3 {\n        font-size: 32px !important;\n    }\n\n    .lanluma-image-hero-1 span {\n        font-size: 18px !important;\n        width: 70% !important;\n    }\n\n    .maili-image-hero-1 h3 {\n        font-size: 2rem;\n        margin-bottom: 8px !important;\n    }\n\n    .ellanse-hero-image-1 h3 {\n        font-size: 29px !important;\n        font-weight: 400 !important;\n    }\n\n    .ellanse-hero-image-1:before {\n        background-position: -100px !important;\n\n    }\n\n    .ellanse-hero-image-1 span {\n        margin-top: 27px !important;\n    }\n\n    .dimono-image-hero-1 {\n        background-position: -25px 100px;\n        background-repeat: no-repeat;\n    }\n\n    .dimono-image-hero-1::before {\n        background-size: 50% !important;\n        /* background-position: 0 110px !important; */\n    }\n\n    .dimono-image-hero-1 {\n        padding-left: 64px !important;\n        background-position: -56px 150px;\n        background-repeat: no-repeat;\n    }\n\n    html[dir='rtl'] .dimono-image-hero-1 {\n        background-position: right;\n    }\n\n    html[dir='rtl'] .dimono-image-hero-1::before {\n        /* transform: none!important; */\n        left: -50%;\n    }\n\n    .dimono-image-hero-1 h3 {\n        font-size: 2rem;\n        font-weight: 400;\n    }\n\n\n    html[dir='rtl'] .drcyj-image-hero-1 {\n\n        padding-right: 60px !important;\n    }\n\n    html[dir='ltr'] .drcyj-image-hero-1 {\n\n        padding-left: 60px !important;\n    }\n\n    .drcyj-story-section-1 span {\n        word-spacing: 0;\n    }\n\n    .maili-image-hero-1 ,.ellanse-hero-image-1{\n        padding-left: 64px !important;\n    }\n\n    html[dir='rtl'] .maili-image-hero-1 ,   html[dir='rtl'] .lanluma-image-hero-1,  html[dir='rtl'] .ellanse-hero-image-1 {\n        padding-right: 64px !important;\n    }\n\n    html[dir='ltr'] .lanluma-image-hero-1, html[dir='ltr'] .ellanse-hero-image-1 {\n        padding-left: 64px !important;\n    }\n    html[dir='rtl'] .lanluma-image-hero-1::before {\n\n        left: -345px;\n        right: unset !important;\n    }\n\n    html[dir='rtl'] .lanluma-image-hero-1 span {\n        font-size: 18px !important;\n        width: 60% !important;\n    }\n    html[dir='rtl'] .ellanse-logo{\n        margin-left: auto!important;\n        margin-right: 0!important;\n    }\n    /* html[dir='rtl'] .ell */\n}\n\n\n\n@media(max-width: 767px) {\n    .ksurgery-image-hero {\n        height: 400px;\n    }\n\n    .ksurgery-image-hero:before {\n        background-position: right !important;\n        background-color: red\n    }\n\n    .ksurgery-image-hero h3 {\n        font-size: 20px !important;\n    }\n\n    .ksurgery-image-hero h4 {\n        font-size: 14px !important;\n        font-weight: 600;\n    }\n\n    .ksurgery-image-hero p,\n    .juvelook-hero-1 p {\n        text-align: left !important;\n    }\n   html[dir='rtl'] .ksurgery-image-hero p,\n   html[dir='rtl']  .juvelook-hero-1 p {\n        text-align: right !important;\n    }\n\n    .ksurgery-image-hero ul {\n        margin-top: 24px !important;\n    }\n\n    .ksurgery-image-hero ul li {\n        font-size: 14px !important;\n    }\n\n    .juvelook-hero-1,\n    .juvelook-hero-2,\n    .leninsa-hero-1 {\n        height: 100vh !important;\n    }\n\n    .leninsa-hero-1 .text-holder,\n    .lensina-image-hero-2 .text-holder {\n        position: relative;\n        top: 50%;\n        transform: translateY(-50%);\n    }\n\n    .leninsa-hero-1 {\n        background-color: rgba(0, 0, 0, 0.6);\n    }\n\n    .ellanse-hero-image-1:before {\n        background-image: none !important;\n    }\n\n    .ellanse-hero-image-1 svg {\n        margin-right: auto !important;\n    }\n\n    .ellanse-hero-image-1 {\n        height: auto !important;\n        padding: 16px 0 !important;\n    }\n\n    .lanluma-image-hero-1 {\n        background-image: none !important;\n        height: 100vh !important;\n\n    }\n\n    .lanluma-image-hero-1::before {\n        background-image: url('assets/lanluma/3.png') !important;\n        transform: none !important;\n        filter: brightness(50%);\n        background-position: 30% !important;\n        background-size: cover !important;\n\n    }\n\n    .lanluma-image-hero-1 h3 {\n        margin-top: 17vh !important;\n        font-size: 2.25rem !important;\n        font-weight: 400 !important;\n    }\n\n    .lanluma-image-hero-1 h3,\n    .lanluma-image-hero-1 span {\n        color: white;\n    }\n\n    .lanluma-image-hero-1 span {\n\n        font-size: 1.125rem !important;\n    }\n\n\n    .maili-image-hero-1 {\n        height: 70vh !important;\n    }\n\n    .text-holder {\n        padding: 32px !important;\n    }\n\n    .maili-image-hero-1:before {\n        background-image: url('assets/maili/1.png') !important;\n        background-size: cover !important;\n        filter: brightness(50%);\n        background-position: center left !important;\n        transform: none !important;\n\n    }\n\n    .maili-image-hero-1 h3 {\n        /* margin-top: 40px!important; */\n    }\n\n    .dimono-image-hero-1 {\n        height: 90vh !important;\n        background-image: url('assets/dimono/mobile-img-hero-bg.svg') !important;\n\n\n        background-position: right bottom !important;\n        background-size: 100px !important;\n        background-repeat: no-repeat !important;\n        z-index: 9;\n        /* filter: grayscale(0.1); */\n    }\n\n    .dimono-image-hero-1:before {\n        background-image: none !important;\n        /* background-color: #E5E5E5; */\n\n    }\n\n    .juvelook-hero-2 h2,\n    .dimono-image-hero-1 h3,\n    .drcyj-image-hero-1 h3,\n    .lanluma-image-hero-1 h3,\n    .lensina-image-hero-2 h2,\n    .lensina-image-hero-1 h2,\n    .juvelook-hero-1 h2 {\n        margin-bottom: 60px !important;\n        margin-top: 17vh !important;\n        font-size: 2.25rem;\n        font-weight: 400 !important;\n\n    }\n\n    .juvelook-hero-2 p,\n    .dimono-image-hero-1 span,\n    .drcyj-image-hero-1 span,\n    .lensina-image-hero-2 span,\n    .juvelook-hero-1 p {\n        font-size: 18px;\n\n    }\n\n    .drcyj-image-hero-1 {\n        height: 100vh !important;\n        /* background-color: red; */\n        background-color: rgba(0, 0, 0, 0.9);\n    }\n\n    .drcyj-image-hero-1:before {\n        background-position: 70% !important;\n        background-size: cover !important;\n        filter: brightness(50%);\n\n    }\n\n    .drcyj-image-hero-1 span,\n    .drcyj-image-hero-1 h3 {\n        color: white !important;\n    }\n\n    .drcyj-image-hero-1:after {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 100%;\n        height: 100%;\n        background-color: rgba(0, 0, 0, 0.3);\n    }\n\n    .lensina-image-hero-2 {\n        height: 100vh !important;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
